import React from "react";

const PILLARS = ["Visao", "Forca", "Estrutura", "Fortaleza", "Dominio Mental"];

export default function PillarRegistryPanel({ badges = [] }) {
  const counts = PILLARS.reduce((acc, pillar) => {
    acc[pillar] = 0;
    return acc;
  }, {});

  (Array.isArray(badges) ? badges : []).forEach((badge) => {
    const pillar = String(badge?.pillar || "");
    if (Object.prototype.hasOwnProperty.call(counts, pillar)) {
      counts[pillar] = Number(badge?.count || 0);
    }
  });

  return (
    <section className="vh-chatrooms-pillars">
      <div className="vh-chatrooms-section-label">Registro do Cacador</div>
      <div className="vh-chatrooms-pillars-grid">
        {PILLARS.map((pillar) => (
          <div key={pillar} className="vh-chatrooms-pillar-card">
            <div className="vh-chatrooms-pillar-name">{pillar}</div>
            <div className="vh-chatrooms-pillar-count">{counts[pillar]}</div>
            <div className="vh-chatrooms-pillar-caption">selos</div>
          </div>
        ))}
      </div>
    </section>
  );
}
